import {
  initializeStateManager,
  isUserLoggedIn,
  getAccessToken,
  hasClientId,
  hasNick,
  setUserLoggedIn
} from './state-manager.js';

import { verifyToken } from './setup/auth/auth.js';
import { 
  startSetupUseCase,
  startLoginUseCase,
  continueSetupFlow,
} from './shared/ui-flow.js';

import { 
  getSetupStage,
  restoreSetupStage,
} from './setup/setup-stage-manager.js';

export async function bootApp() {
  console.log('[Bootloader] Initializing application...');
  initializeStateManager();

  restoreSetupStage(); // Restore progress from localStorage

  const isFirstRun = !hasClientId() || !hasNick();

  if (isFirstRun) {
    console.log('[Bootloader] First-time setup required');
    startSetupUseCase(); // Begin client registration path
    return;
  }

  if (isUserLoggedIn()) {
    const token = getAccessToken();

    console.log('[Bootloader] Verifying token...');
    const isValid = await verifyToken(token);

    if (isValid) {
      const stage = getSetupStage();
      console.log('[Bootloader] Token verified. Setup stage:', stage);
      continueSetupFlow(); // Resume setup or load app
    } else {
      console.warn('[Bootloader] Token invalid. Redirecting to login.');
      setUserLoggedIn(false);
      startLoginUseCase(); // Force manual login
    }
  } else {
    console.log('[Bootloader] Not logged in. Starting login flow...');
    startLoginUseCase(); // Auto-fill with saved clientId
  }
}